module.exports = __webpack_public_path__ + "static/media/CreditCard.d52efcaa.svg";